import { useI18next } from "gatsby-plugin-react-i18next"
import styled from "styled-components"

import GalileoLogo from "images/careers/Logo.webp"
import GalileoLogoWhite from "images/global/galileoLogo.webp"
import media from "styles/media"
import UniversalLink from "utils/Loader/UniversalLink"

export default function HeroLogo({
  lightmode = false,
  languageOverride,
}: {
  lightmode?: boolean
  languageOverride?: string
  
}) {
  const { language } = useI18next()
  const slug = languageOverride ?? language 

  const localeLink = slug  === "en" ? "/" : `/${slug}/`

  return (
    <UniversalLink to={localeLink}>
      <Logo
        src={lightmode ? GalileoLogo : GalileoLogoWhite}
        alt="Galileo"
        className="galileo_Logo"
      />
    </UniversalLink>
  )
}

const Logo = styled.img`
  cursor: pointer;
  ${media.fullWidth} {
    width: 144px;
    height: 30px;
  }
  ${media.desktop} {
    width: 8.675vw;
    height: 1.807vw;
  }
  ${media.tablet} {
    width: 14.063vw;
    height: 2.93vw;
  }
  ${media.mobile} {
    width: 32vw;
    height: 6.667vw;
  }
`
